import { useQuery } from '@tanstack/react-query';
import { ResultHelpers } from '@treneo/models';

import { coursesApi } from '../../../data/api';
import { COURSE_TAGS_QUERY_KEY } from '../../../data/courses-query-keys';

const GET_COURSE_TAGS_TIMEOUT_MS = 15000;

const COURSE_TAGS_STALE_TIME_MS = 5 * 60 * 1000;

export const useCourseTagsQuery = () =>
  useQuery({
    queryKey: COURSE_TAGS_QUERY_KEY,
    queryFn: async ({ signal }) => {
      const result = await coursesApi.getCourseTags(
        signal ?? undefined,
        GET_COURSE_TAGS_TIMEOUT_MS
      );

      return ResultHelpers.unwrap(result, 'Get course tags failed');
    },
    staleTime: COURSE_TAGS_STALE_TIME_MS,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });
